import React from 'react';
import './Feature.css';
import nature from "../assets/images/nature.png";
import comfort from "../assets/images/comfort.png";
import finest from "../assets/images/finest.png";
import premium from "../assets/images/premium.png";

export default function Feature() {
  return (
    <div className='feature_outer'>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="feature_main">
              <div className='feature_img'>
                 <img src={nature} alt="Logo" className="img-fluid" />
              </div>
              <div className='feature_desc'>
                <h5>Naturally Inspired</h5>
                <p>Inspired by nature’s textures and tones to bring a calm, organic feel to your space.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="feature_main">
              <div className='feature_img'>
                 <img src={finest} alt="Logo" className="img-fluid" />
              </div>
              <div className='feature_desc'>
                <h5>Finest Craftsmanship</h5>
                <p>Inspired by nature’s textures and tones to bring a calm, organic feel to your space.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="feature_main">
              <div className='feature_img'>
                 <img src={premium} alt="Logo" className="img-fluid" />
              </div>
              <div className='feature_desc'>
                <h5>Premium Quality</h5>
                <p>Inspired by nature’s textures and tones to bring a calm, organic feel to your space.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="feature_main">
              <div className='feature_img'>
                 <img src={comfort} alt="Logo" className="img-fluid" />
              </div>
              <div className='feature_desc'>
                <h5>Crafted for Comfort</h5>
                <p>Inspired by nature’s textures and tones to bring a calm, organic feel to your space.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}
